module.exports = __webpack_public_path__ + "static/media/facebookIcon.b0eece2c.svg";